import queryString from 'query-string';
import portalCommunication from './helpers/portal-communication';

export default class PortalCommunication {
    static Configure() {
        portalCommunication.requestLoadingSpinner(false);
    }

    // invoke this method to let the 3p-portal know
    // that we want to navigate to current module landing screen
    static navigateToLandingScreen(moduleName = '') {
        portalCommunication.requestNavigateToLanding(moduleName);
    }

    // invoke this method to let the 3p-portal know
    // to make a api call
    static informMakeAPICall(param) {
        portalCommunication.informMakeAPICall(param);
    }

    static serverError(error) {
        portalCommunication.requestServerError(error);
    }

    static requestModuleChange({ moduleId, classId, classroomName, groupId, sourceModuleId }) {
        const queryParams = queryString.parse(location.search);
        const lang = queryParams.lang;
        const backUrl = encodeURIComponent(window.location.href);
        portalCommunication.requestModuleChange(moduleId, { lang, classId, classroomName, groupId, backUrl, sourceModuleId });
    }
}



// WEBPACK FOOTER //
// ./app/portal-comms.js